// extracted by mini-css-extract-plugin
export var newsletterBannerContainer = "newsletter-banner-module--newsletterBannerContainer--b8397";
export var newsletterBannerContent = "newsletter-banner-module--newsletterBannerContent--8cbf0";